import type { AccountRepository } from "../../index";
import type { BalanceModel } from "../../models/balance.model";

export default class AccountsController {
  constructor(private repo: AccountRepository) {}

  async getAccounts() {
    return this.repo.getAccounts()
  }

  async getBalances(): Promise<BalanceModel[]> {
    return this.repo.getBalances()
  }
}